export default __webpack_public_path__ + "static/media/logo.b89ba7de.png";